<template lang='pug'>
  .container
    .row(style="display: flex; justify-content: center; flex-direction: row")
      .headline
        h3.text-center Top-News aus dem HR-Bereich
      .text-center
        .dropdown.dropdown-container(style="position: relative")
          button#dropdownCategories.btn.btn-default.dropdown-toggle(type='button', data-toggle='dropdown', aria-haspopup='true', aria-expanded='true')
            | {{ sortTitle }} 
            span.caret
          ul.dropdown-menu(:text='sortTitle' aria-labelledby='dropdownCategories')
            li(onclick="return false" @click='setFilter(null)')
              a(href='') Alle Kategorien
            li(v-for="categorie in categories" @click='setFilter(categorie)')
              a(onclick="return false" href='') {{ categorie.name }}
    .row.hrfilter-buttons
      .col-md-4(v-if='true')
        a(v-bind:href="categoryURL" target="_blank")
          button.btn.btn-primary.btn-hrfilter.center-block {{ categoryButton }} 
      .col-md-4
        a(href="https://www.hrfilter.de/newsletter" target="_blank")
          button.btn.btn-primary.btn-hrfilter.center-block Aktuelle HR-News abonnieren
      .col-md-4
        a(href="https://www.hrfilter.de/app" target="_blank")
          button.btn.btn-primary.btn-hrfilter.center-block HRFilter als App
                
    br
    br

    transition(name='fade')
      .text-center.loading-indicator(v-if='isloading')
        i.fa.fa-spinner.fa-spin.fa-3x.fa-fw(aria-hidden='true')
    transition(name='fade')
      div(v-if='!isloading')
        .row(v-if='newsCount > 0')
          .col-md-3.col-sm-6.col-xs-12(v-for='news in slicedNews')
            news-panel(:news="news")
            br
        .row(v-else)
          h2 Keine Nachrichten in dieser Kategorie gefunden

        button.btn.btn-primary.btn-hrfilter.center-block(@click="newsTotal += newsPerRow" v-if="loadMore")
          | Mehr

</template>

<script>

import NewsPanel from './news'
import _sortBy from 'lodash/sortBy'

export default {
  components: {
    NewsPanel
  },
  data() {
    return {
      categories: null,
      news: null,
      selectedCategory: null,
      ishover: false,
      isloading: true,
      newsTotal: 4,
    }
  },
  mounted() {
    this.$http.get('https://www.hrfilter.de/api/v1/categories.json')
      .then((response) => {
        this.categories = response.data.categories;
      });
    this.reloadNews()
  },
  methods: {
    reloadNews() {
      this.isloading = true
      this.news = []
      this.$http.get("https://www.hrfilter.de/api/v1/news_items.json?limit=12&image_exists=0&teaser_enabled=0", {
        params: {
          categories: this.selectedCategory != null ? this.selectedCategory.id : null
        }
      })
        .then((response) => {
          this.news = response.data.news_items;
          this.isloading = false;
        })
    },
    setFilter(categorie) {
      this.selectedCategory = categorie
      this.reloadNews()
      this.newsTotal = 4;
    },
  },
  computed: {
    loadMore() {
      if (this.newsCount - this.newsTotal > 0) {
        return true;
      }
      else {
        return false;
      }
    },
    newsPerRow() {
      const screenWidth = screen.width;

      if (screenWidth > 970) {
        return 4;
      }
      else if (screenWidth > 750) {
        return 2;
      }
      else {
        return 1;
      }
    },
    categoryURL() {
      if(this.selectedCategory) {
        return "https://www.hrfilter.de/kategorien/" + this.selectedCategory.slug;
      }
      else {
        return "http://www.hrfilter.de/kategorien";
      }
    },
    categoryButton() {
      if (this.selectedCategory)
        return "Alle News zum Thema " + this.selectedCategory.name;
      else
        return "Alle Kategorien auf HRfiler.de";
    },
    newsCount() {
      return this.filteredNews.length;
    },
    sortTitle() {
      if (this.selectedCategory) {
        return this.selectedCategory.name;
      } else {
        return " Alle Kategorien";
      }
    },
    slicedNews() {
      return this.filteredNews.slice(0, this.newsTotal);
    },
    filteredNews() {
      return this.news;
    },
    sortCategories() {
      return _sortBy(this.categories, ['name']);
    }
  }
}
</script>

<style lang='scss' scoped>

.dropdown-container {
  margin-top: 17px;
}

.headline {
  margin-right: 5px;
}

.caret {
  margin-left: 5px;
}

.fade-enter-active, .fade-leave-active {
  transition: opacity 1s ease-in-out;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.loading-indicator {
  position: absolute;
  z-index: 2;
  width: 100%;
  margin-top: 50px;
}

.hrfilter-buttons {
  display: flex;
  justify-content: center;
}

</style>
